import 'css-chunksrc/client/pages/personalSpacePage/synthesis/calendarWidget/styles.scss';export default {
  "widget": "_widget_bug6w_1",
  "header": "_header_bug6w_10",
  "monthYear": "_monthYear_bug6w_15",
  "subHeader": "_subHeader_bug6w_22",
  "weekSelectorRoot": "_weekSelectorRoot_bug6w_30",
  "weekCalendarDropdown": "_weekCalendarDropdown_bug6w_34",
  "weekSelector": "_weekSelector_bug6w_30",
  "weekLabel": "_weekLabel_bug6w_56",
  "arrow": "_arrow_bug6w_63",
  "todayLabel": "_todayLabel_bug6w_74",
  "content": "_content_bug6w_81",
  "dayList": "_dayList_bug6w_87",
  "resizeHandle": "_resizeHandle_bug6w_95",
  "unselectable": "_unselectable_bug6w_117",
  "dayRow": "_dayRow_bug6w_121",
  "dayRowSelected": "_dayRowSelected_bug6w_137",
  "dayRowToday": "_dayRowToday_bug6w_141",
  "dayNumber": "_dayNumber_bug6w_144",
  "dayRowHoliday": "_dayRowHoliday_bug6w_150",
  "dayRowWeekend": "_dayRowWeekend_bug6w_154",
  "dayInfo": "_dayInfo_bug6w_158",
  "dayName": "_dayName_bug6w_168",
  "dayMonth": "_dayMonth_bug6w_186",
  "dayItems": "_dayItems_bug6w_193",
  "dayItemMore": "_dayItemMore_bug6w_203",
  "calendarBar": "_calendarBar_bug6w_209",
  "calendarBarIcon": "_calendarBarIcon_bug6w_220",
  "calendarBarIconLight": "_calendarBarIconLight_bug6w_228",
  "calendarBarIconDark": "_calendarBarIconDark_bug6w_232",
  "calendarBarIconCompleted": "_calendarBarIconCompleted_bug6w_236",
  "calendarBarTime": "_calendarBarTime_bug6w_240",
  "calendarBarName": "_calendarBarName_bug6w_247",
  "calendarBarClickable": "_calendarBarClickable_bug6w_254",
  "holidayBar": "_holidayBar_bug6w_261",
  "holidayName": "_holidayName_bug6w_271",
  "unavailabilityBar": "_unavailabilityBar_bug6w_279",
  "unavailabilityIcon": "_unavailabilityIcon_bug6w_290",
  "unavailabilityName": "_unavailabilityName_bug6w_297",
  "milestoneBar": "_milestoneBar_bug6w_305",
  "milestoneBarClickable": "_milestoneBarClickable_bug6w_315",
  "milestoneBarIcon": "_milestoneBarIcon_bug6w_322",
  "milestonBarName": "_milestonBarName_bug6w_331",
  "rightPanel": "_rightPanel_bug6w_340",
  "milestonesSection": "_milestonesSection_bug6w_348",
  "milestoneRow": "_milestoneRow_bug6w_355",
  "milestoneRowClickable": "_milestoneRowClickable_bug6w_362",
  "milestoneIcon": "_milestoneIcon_bug6w_371",
  "milestoneName": "_milestoneName_bug6w_378",
  "milestonesPlaceholder": "_milestonesPlaceholder_bug6w_386",
  "timeViewSection": "_timeViewSection_bug6w_392"
};